import React, {useEffect, useState} from "react";
import {UpOutlined} from "@ant-design/icons";
import {Button} from "antd";
import "./style.less"


type ScrollToTopButtonProps = {
  elementSelector: string
}

const ScrollToTopButton: React.FC<ScrollToTopButtonProps> = (props) => {
  const {elementSelector} = props
  const [visible, setVisible] = useState(false);


  const scrollToTop = () => {
    const el = document.querySelector(elementSelector);
    el?.scrollTo({top: 0, behavior: "smooth"});
  };

  useEffect(() => {
    const el = document.querySelector(elementSelector);
    const handleScroll = () => {
      if (el) {
        setVisible(el.scrollTop > 300);
      }

    };

    el?.addEventListener("scroll", handleScroll);
    return () => {
      el?.removeEventListener("scroll", handleScroll);
    };
  }, []);

  if (!visible) return null;

  return (
    <Button
      size="large"
      type="text"
      icon={<UpOutlined/>}
      onClick={scrollToTop}
      className="scroll-to-top-button"
    />
  );
};

export default ScrollToTopButton;